import React, { useEffect, useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import ColorPickerField from "../../../components/Fields/ColorPickerField";
import DateControl from "../../../components/Fields/DateControl";
import Field from "../../../components/Fields/Field";
import FieldLabel from "../../../components/Fields/FieldLabel";
import NumberField from "../../../components/Fields/NumberField";
import TextboxField from "../../../components/Fields/TextboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import ColorModel from "../../../models/ColorModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";
import FormatUtils from "../../../utils/FormatUtils";

const AddColorPopup: React.FC<PopupProps> = ({ show, onHide }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();
    const [formData, setFormData] = useState<ColorModel>();

    useEffect(() => {
        setFormData({
            id: 0,
            name: '',
            abbreviation: '',
            colorCode: '',
            textColorCode: '',
            beginDate: new FormatUtils().formatDateForStorage(new Date()),
            endDate: '',
            concurrencyId: ''
        } as ColorModel);
    }, [])

    function submit() {
        if (formData) {
            DataService
                .create<number>(`api/v1/Colors`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'name', label: 'Name', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
            { name: 'abbreviation', label: 'Abbreviation', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
            { name: 'colorCode', label: 'Color code', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
            { name: 'textColorCode', label: 'Text color code', labelSize: 2 },
            { name: 'sortOrder', label: 'Sort order', labelSize: 2 },
            { name: 'beginDate', label: 'Active from', validationRules: [{ type: 'isRequired' }, { type: 'isDate' }] },
            { name: 'endDate', label: 'Active until', labelSize: 'auto', validationRules: [{ type: 'isDate' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getLabelProps, getControlProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add color'} >
            <Popup.Body>
                <TextboxField {...getFieldProps('name')} />
                <TextboxField {...getFieldProps('abbreviation')} />
                <ColorPickerField {...getFieldProps('colorCode')} />
                <ColorPickerField {...getFieldProps('textColorCode')} />
                <NumberField {...getFieldProps('sortOrder')} />
                <Field {...getLabelProps('beginDate')}>
                    <DateControl {...getControlProps('beginDate')} />
                    <span style={{ padding: '7px 15px' }}><FieldLabel {...getLabelProps('endDate')} /></span>
                    <DateControl {...getControlProps('endDate')} />
                </Field>
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddColorPopup;